module.exports = __webpack_public_path__ + "static/media/illu-free.aeee56bb.png";